export function detectLanguage(supportedLangs, defaultLang) {
	const locales = navigator.languages ?? [navigator.language];

	for (const locale of locales) {
		const lang = locale.toLowerCase().split(/[-_]/)[0];
		if (supportedLangs.includes(lang)) {
			return lang;
		}
	}

	return defaultLang; // fallback
}
